import { createStepRegistry } from "../../utils/flowAnalytics/createStepRegistry.js";
import { normalizeEntryFlowSlug, normalizeFlowSlug } from "../../utils/flowAnalytics/flowSlug.js";
import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import VafActivityDescription from "../steps/VafActivityDescription.jsx";
import VafContactPage from "../steps/VafContactPage.jsx";
import VafIndustryActivity from "../steps/VafIndustryActivity.jsx";
import VafIndustrySelect from "../steps/VafIndustrySelect.jsx";
import VafSuccessScreen from "../steps/VafSuccessScreen.jsx";

/**
 * Stable step metadata keyed by React component.
 * stepId values are persisted in MongoDB — do not rename; add new entries for new steps.
 */
const STEP_META_BY_COMPONENT = new Map([
  [VafIndustrySelect, { id: "vaf_industry_select", phase: "vaf" }],
  [VafIndustryActivity, { id: "vaf_industry_activity", phase: "vaf" }],
  [VafActivityDescription, { id: "vaf_activity_description", phase: "vaf" }],
  [VafContactPage, { id: "vaf_contact_page", phase: "vaf" }],
  [VafSuccessScreen, { id: "vaf_success_screen", phase: "vaf" }],
  [GeneralError, { id: "vaf_general_error", phase: "vaf" }],
]);

/**
 * Context fields owned by each step — only these are sent on events for that step.
 * Persisted in MongoDB; add keys here when a step collects new analytics dimensions.
 */
export const STEP_CONTEXT_FIELDS = {
  vaf_industry_select: ["industry", "companytype"],
  vaf_industry_activity: ["industry", "companytype"],
};

const vafFlowStepRegistry = createStepRegistry({
  metaByComponent: STEP_META_BY_COMPONENT,
  contextFieldsByStepId: STEP_CONTEXT_FIELDS,
});

export const { getStepMeta, getStepMetaAtIndex, getStepContextFieldKeys } =
  vafFlowStepRegistry;

export default vafFlowStepRegistry;

export { normalizeEntryFlowSlug, normalizeFlowSlug };
